<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="main-content" style="padding-bottom: 57px;">
    <div class="my-card">
        <p-toolbar styleClass="mb-3 gap-2">
            <ng-template pTemplate="left">
                <h4>Agregar Invitado</h4>
            </ng-template>
            <ng-template pTemplate="right">
            </ng-template>
        </p-toolbar>

        <div *ngIf="assignments.length > 0 && assignments[0].assignmentLoan">
            <h5 style="text-align: center; padding: 20px; color: #DA291C;">
                <b>¡Asignación temporal activa!</b>, Eliminar o esperar a que expire su vigencia
            </h5>
            <p-table [value]=" assignments" [tableStyle]="{ 'min-width': '50rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Código de Colaborador</th>
                        <th>Nombre Colaborador</th>
                        <th>Correo</th>
                        <th>Fecha de inicio</th>
                        <th>Fecha de expiración</th>
                        <th>Estado</th>
                        <th>Acción</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-assignment>
                    <tr>
                        <td> {{ assignment.assignmentLoan.employee.employeeCode }} </td>
                        <td> {{ assignment.assignmentLoan.employee.name }} </td>
                        <td> {{ assignment.assignmentLoan.employee.email }} </td>
                        <td>{{ assignment.assignmentLoan.startDateAssignment | date:'dd/MM/yyyy' }}</td>
                        <td>{{ assignment.assignmentLoan.endDateAssignment | date:'dd/MM/yyyy' }}</td>
                        <td> {{ assignment.assignmentLoan.status }} </td>
                        <td style="padding: 20px;">
                            <p-button severity="danger"
                                (onClick)="removeAssignment(assignment.assignmentLoan.id)">Eliminar</p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <p-toolbar styleClass="mt-4 gap-2">
                <ng-template pTemplate="left">

                </ng-template>
                <ng-template pTemplate="center">

                    <p-button severity="info" label="Regresar" icon="pi pi-angle-double-left" class="mr-2"
                        (onClick)="redirectSearchAssignment()" />

                </ng-template>
                <ng-template pTemplate="end">

                </ng-template>
            </p-toolbar>

        </div>

        <!--Busca información de los empleados-->
        <div *ngIf="assignments && assignments[0] && !assignments[0].assignmentLoan">

            <p-panel header="Obtener Datos del Colaborador">

                <form [formGroup]="employeeForm" class="p-fluid" autocomplete="off">
                    <div class="grid ">
                        <div class="col-12 xl:col-3">
                            <label for="id">Código de Colaborador</label>
                            <input class="mr-3" id="id" pInputText formControlName="id" placeholder="Ingrese el Código"
                                (keydown.enter)="onSearch()">
                            <div class="p-error block" *ngIf="errorMessageSearch">
                                {{ errorMessageSearch }}
                            </div>
                        </div>
                    </div>
                </form>
            </p-panel>
            <form [formGroup]="assignmentForm" (ngSubmit)="confirmAssignment()" class="p-fluid" autocomplete="off">
                <p-panel header="información del Colaborador" styleClass="pt-5">

                    <div formGroupName="employee">

                        <div class="grid">

                            <div class="col-12 xl:col-3">
                                <label for="name">Nombre Colaborador</label>
                                <input id="name" formControlName="name" pInputText readonly />
                                <div class="p-error block"
                                    *ngIf="this.assignmentForm.get('employee.name')?.errors?.['required'] && !this.assignmentForm.get('employee.name')?.pristine">
                                    Nombre Requerido
                                </div>
                            </div>

                        </div>
                        <div class="grid">
                            <div class="col-12 xl:col-3">
                                <label for="workplace">Puesto Colaborador </label>
                                <input id="workplace" formControlName="workplace" pInputText readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="identifierDocument">Documento de Identificación</label>
                                <input id="identifierDocument" formControlName="identifierDocument" pInputText
                                    readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="company">Compañia</label>
                                <input id="company" formControlName="company" pInputText readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="department">Departamento</label>
                                <input id="department" formControlName="department" pInputText readonly />
                            </div>
                        </div>

                        <div class="grid">
                            <div class="col-12 xl:col-3">
                                <label for="subManagement">Subgerencia</label>
                                <input id="subManagement" formControlName="subManagement" pInputText readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="management1">Gerencia 1</label>
                                <input id="management1" formControlName="management1" pInputText readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="management2">Gerencia 2</label>
                                <input id="management2" formControlName="management2" pInputText readonly />
                            </div>
                            <div class="col-12 xl:col-3">
                                <label for="workSite">Lugar de Trabajo</label>
                                <input id="workSite" formControlName="workSite" pInputText readonly />
                            </div>
                        </div>

                        <div class="grid">
                            <div class="col-12 xl:col-3">
                                <label for="address">Dirección</label>
                                <input id="address" formControlName="address" pInputText readonly />
                            </div>

                            <div class="col-12 xl:col-3">
                                <label for="email">Correo</label>
                                <input id="email" formControlName="email" pInputText readonly />
                            </div>

                            <div class="col-12 xl:col-3">
                                <label for="phone">Número de Teléfono</label>
                                <input formControlName="phone" pInputText readonly />
                            </div>
                        </div>

                        <div class="pt-5">
                            <h6><strong>Vehículos Invitados</strong></h6>
                            <div formArrayName="vehicles">
                                <p-toolbar styleClass="mb-4 gap-2">
                                    <ng-template pTemplate="left">
                                        <p-button severity="success" label="Agregar vehículo" icon="pi pi-plus"
                                            (onClick)="addVehicle()" />
                                    </ng-template>
                                </p-toolbar>

                                <div *ngFor="let vehicle of vehicles.controls; let i = index" [formGroupName]="i"
                                    class="grid">
                                    <div class="col-12 xl:col-2">
                                        <label for="vehicleBadge">Placa</label>
                                        <input id="vehicleBadge" formControlName="vehicleBadge" pInputText
                                            placeholder="X###XXX" maxlength="7" />
                                        <div class="p-error block"
                                            *ngIf="vehicle.get('vehicleBadge')?.errors?.['required'] && !vehicle.get('vehicleBadge')?.pristine">
                                            Placa Requerida.
                                        </div>
                                        <div class="p-error block"
                                            *ngIf="vehicle.get('vehicleBadge')?.errors?.['pattern']">
                                            Formato invalido
                                        </div>
                                    </div>
                                    <div class="col-12 xl:col-2">
                                        <label for="color">Color</label>
                                        <input id="color" formControlName="color" pInputText maxlength="20" />
                                    </div>
                                    <div class="col-12 xl:col-2">
                                        <label for="brand">Marca</label>
                                        <input id="brand" formControlName="brand" pInputText maxlength="20" />
                                    </div>

                                    <div class="col-12 xl:col-2">
                                        <label for="model">Modelo</label>
                                        <input id="model" formControlName="model" pInputText placeholder="####"
                                            maxlength="4" />
                                        <div class="p-error block"
                                            *ngIf="vehicle.get('model')?.errors?.['required'] && !vehicle.get('model')?.pristine">
                                            Año Requerido.
                                        </div>
                                        <div class="p-error block" *ngIf="vehicle.get('model')?.errors?.['pattern']">
                                            Formato invalido
                                        </div>
                                    </div>

                                    <div class="col-12 xl:col-2">
                                        <label for="type">Tipo</label>
                                        <p-dropdown formControlName="type" [options]="vehicleTypes"
                                            placeholder="Selecione Tipo" [autoWidth]="false"
                                            required="true"></p-dropdown>
                                    </div>

                                    <div class="col-12 xl:col-2">
                                        <label for="type">Acción</label>
                                        <div>
                                            <p-button icon="pi pi-trash" severity="danger" size="small"
                                                (click)="confirmDelVehicle(i)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pt-5">
                        <h6><strong>Fechas</strong></h6>
                        <div class="grid">
                            <div class="col-12 xl:col-3">
                                <label for="startDateAssignment">Fecha de Inicio</label>
                                <p-calendar id="startDateAssignment" formControlName="startDateAssignment"
                                    dateFormat="dd-mm-yy" [minDate]="today" [maxDate]="maxDateGuest"></p-calendar>
                            </div>

                            <div class="col-12 xl:col-3">
                                <label for="endDateAssignment">Fecha de Fin</label>
                                <p-calendar id="endDateAssignment" formControlName="endDateAssignment"
                                    dateFormat="dd-mm-yy" [minDate]="minDate" [maxDate]="maxDate"></p-calendar>
                            </div>

                        </div>
                    </div>

                </p-panel>

                <div class="flex justify-content-center gap-3 pt-5">
                    <p-button label="Guardar Invitado" [disabled]="assignmentForm.invalid"
                        class="custom-guardar w-12rem" type="submit">
                    </p-button>

                    <p-button label="Cancelar" (onClick)="confirmCancel()" [outlined]="true" severity="secondary"
                        class="custom-cancelar w-12rem">
                    </p-button>
                </div>

            </form>
        </div>
    </div>

</div>
